"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.6.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KindEnum = void 0;
exports.instanceOfKindEnum = instanceOfKindEnum;
exports.KindEnumFromJSON = KindEnumFromJSON;
exports.KindEnumFromJSONTyped = KindEnumFromJSONTyped;
exports.KindEnumToJSON = KindEnumToJSON;
exports.KindEnumToJSONTyped = KindEnumToJSONTyped;
/**
 * * `NW` - Not Working
 * * `SE` - Spelling Error
 * * `II` - Incorrect Info
 * * `WC` - Wrong Card
 * * `VG` - Variant Grouping
 * * `O` - Other
 * @export
 * @enum {string}
 */
var KindEnum;
(function (KindEnum) {
    KindEnum["Nw"] = "NW";
    KindEnum["Se"] = "SE";
    KindEnum["Ii"] = "II";
    KindEnum["Wc"] = "WC";
    KindEnum["Vg"] = "VG";
    KindEnum["O"] = "O";
})(KindEnum || (exports.KindEnum = KindEnum = {}));
function instanceOfKindEnum(value) {
    for (const key in KindEnum) {
        if (Object.prototype.hasOwnProperty.call(KindEnum, key)) {
            if (KindEnum[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function KindEnumFromJSON(json) {
    return KindEnumFromJSONTyped(json, false);
}
function KindEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function KindEnumToJSON(value) {
    return value;
}
function KindEnumToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=kindEnum.js.map